import React from 'react';

const DogSetting = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M24.8438 15C26.1382 15 27.1875 13.9507 27.1875 12.6562C27.1875 11.3618 26.1382 10.3125 24.8438 10.3125C23.5493 10.3125 22.5 11.3618 22.5 12.6562C22.5 13.9507 23.5493 15 24.8438 15Z"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.15625 15C6.45067 15 7.5 13.9507 7.5 12.6562C7.5 11.3618 6.45067 10.3125 5.15625 10.3125C3.86183 10.3125 2.8125 11.3618 2.8125 12.6562C2.8125 13.9507 3.86183 15 5.15625 15Z"
        stroke="CurrentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7812 9.375C12.0757 9.375 13.125 8.32567 13.125 7.03125C13.125 5.73683 12.0757 4.6875 10.7812 4.6875C9.48683 4.6875 8.4375 5.73683 8.4375 7.03125C8.4375 8.32567 9.48683 9.375 10.7812 9.375Z"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2188 9.375C20.5132 9.375 21.5625 8.32567 21.5625 7.03125C21.5625 5.73683 20.5132 4.6875 19.2188 4.6875C17.9243 4.6875 16.875 5.73683 16.875 7.03125C16.875 8.32567 17.9243 9.375 19.2188 9.375Z"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0001 12.1875C14.0859 12.1878 13.1965 12.4851 12.4659 13.0346C11.7353 13.5842 11.2029 14.3561 10.949 15.2344C10.5737 16.5261 9.70302 17.6171 8.5267 18.2695C7.67274 18.7248 7.02787 19.4927 6.72694 20.4124C6.426 21.3322 6.4923 22.3327 6.91197 23.2048C7.33163 24.0768 8.07218 24.7528 8.97874 25.0915C9.88531 25.4301 10.8877 25.4052 11.7763 25.0219C13.8413 24.1752 16.1566 24.1752 18.2216 25.0219C19.1102 25.4052 20.1126 25.4301 21.0192 25.0915C21.9257 24.7528 22.6663 24.0768 23.086 23.2048C23.5056 22.3327 23.5719 21.3322 23.271 20.4124C22.9701 19.4927 22.3252 18.7248 21.4712 18.2695C20.2955 17.6169 19.4256 16.5259 19.0513 15.2344C18.7974 14.3561 18.265 13.5842 17.5344 13.0346C16.8037 12.4851 15.9144 12.1878 15.0001 12.1875Z"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DogSetting;
